import React, { FC } from 'react';
import * as S from './styled';

export interface Props {
	scale?: number;
	color?: string;
}

export const SpinLoader: FC<Props> = props => {
	const { color = '#89FFAC', scale = 0.3 } = props;
	return (
		<S.Spinner color={color} scale={scale}>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</S.Spinner>
	);
};
